import { Button, Flex, Input, useClipboard } from '@ritualco/jutsu'
import { useContent } from 'lib/content/react'

export type ClipboardProps = {
  value: string
}

export const Clipboard = ({ value }: ClipboardProps) => {
  const { hasCopied, onCopy } = useClipboard(value)
  const { formatMessage } = useContent()
  return (
    <Flex>
      <Input flex="1" mr="3" value={value} readOnly />
      <Button onClick={onCopy}>
        {formatMessage({
          id: hasCopied
            ? 'pmportal.global.copyConfirm'
            : 'pmportal.global.copyAction',
        })}
      </Button>
    </Flex>
  )
}
